import styled, { css } from 'styled-components';
import Grid from '$components/layout/Grid';
import { vars, media } from '$util/theme';
import {
  desktopBodyLargeCss,
  desktopTitleH1Css,
  mobileTitleH1Css,
  mobileTitleH4Css,
} from '$base-styles/typography';
import { ReviewProvider } from '$constants/review-providers';

const { container } = vars.mediaQueryBreakpoints;
const { blue } = vars.quantumverse.shadow;

export const Styled = styled.div<{ $reviewsProvider?: ReviewProvider }>`
  display: flex;
  flex-direction: column;
  position: relative;

  ${media.down('sm')} {
    flex-direction: column-reverse;
  }
  ${media.up('md')} {
    min-height: 676px;

    .vrm {
      max-width: initial;
    }
  }
  > .container {
    max-width: ${container}px;
  }
  > div {
    width: 100%;
    margin: auto;
    ${media.down('sm')} {
      padding: 0;
    }
    ${media.up('md')} {
      padding: 26px 80px;
    }
  }

  .Card {
    ${media.down('sm')} {
      text-align: center;
      border-radius: 0;
      padding: 0 !important;
    }
    ${media.up('md')} {
      padding: 24px 34px !important;
    }
    ${media.up('lg')} {
      min-width: 524px;
    }
  }

  .Heading {
    ${mobileTitleH1Css};

    ${media.up('sm')} {
      ${desktopTitleH1Css};
    }
  }

  .subheading {
    ${mobileTitleH4Css};

    ${media.up('sm')} {
      ${desktopBodyLargeCss};
    }
  }

  .headings {
    ${media.down('sm')} {
      padding: 28px 16px 0;
    }
  }

  .Button {
    box-shadow: ${blue};
  }

  .trust {
    display: flex;
    justify-content: space-around;
    ${media.down('sm')} {
      padding: 30px 16px 0;
    }
    ${media.up('sm')} {
      padding: 36px 0 0;
    }
    > div {
      flex: 1 1 50%;
    }
  }

  .ask-experts {
    margin: 24px 0 0;
  }

  ${media.down('sm')} {
    .AskInHouseExperts {
      border-radius: 0;
    }
  }

  .DynamicRouteVrmLookup {
    .Tag {
      margin-left: 1em;
      color: currentColor;
    }
  }

  ${({ $reviewsProvider }) =>
    $reviewsProvider === ReviewProvider.GOOGLE &&
    css`
      .AllianzInsured {
        flex-direction: column;
        row-gap: 5px;
      }
    `}

  .GoogleReviewsSummary a {
    row-gap: 0;
    justify-content: center;
    flex-direction: column;

    .score-wrapper {
      column-gap: 6px;
    }

    .reviews-text {
      display: none;
    }
  }
`;

export const AntGrid = styled(Grid)``;

export const StyledImageContainer = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }

  ${media.down('sm')} {
    span {
      height: 156px !important;
    }

    img {
      clip-path: polygon(0% 0%, 100% 0%, 100% 80%, 50% 100%, 0% 80%);
    }
  }

  ${media.down('md')} {
    height: 156px;
  }

  ${media.up('md')} {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    height: 100%;
  }

  .image-text {
    position: absolute;
    z-index: 10;
    display: flex;
    flex-direction: column;

    ${media.down('sm')} {
      top: 31px;
      /* This calculation is based on the design layouts and ensures the position across mobile viewports is relatively positioned as per the design */
      left: ${() => `calc(50% + ${23 / (375 / 100)}vw)`};
      align-items: flex-start;
    }
    ${media.up('md')} {
      text-align: right;
      align-items: flex-end;
    }
    ${media.between('md', 'lg')} {
      top: 136px;
      right: 44px;
    }
    ${media.up('lg')} {
      top: 146px;
      right: 80px;
    }
  }

  .saving {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${vars.quantumverse.reskinColors.white};
    color: ${vars.quantumverse.reskinColors.neutral600};
    text-transform: uppercase;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: 0.01em;
    margin-bottom: 12px;
    border-radius: 4px;

    ${media.down('sm')} {
      font-size: 13px;
      height: 19px !important;
      padding: 0 8px;
    }
    ${media.between('md', 'lg')} {
      font-size: 20px;
      height: 32px;
      padding: 0 12px;
    }
    ${media.up('lg')} {
      font-size: 30px;
      height: 39px;
      padding: 0 16px;
    }
  }

  .operation {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.01em;
    color: ${vars.quantumverse.reskinColors.white};
    white-space: break-spaces;

    ${media.down('sm')} {
      font-size: 13px;
      line-height: 15px;
    }
    ${media.between('md', 'lg')} {
      font-size: 20px;
      line-height: 26px;
    }
    ${media.up('lg')} {
      font-size: 30px;
    }
  }

  .first-name {
    font-weight: 600;
    line-height: 32px;
    font-size: 20px;
    margin-top: 12px;
    color: ${vars.quantumverse.reskinColors.white};
  }
`;
